/**
 *
 * @author Aleynikov Boris <alynikov.boris@gmail.com>.
 */

'use strict';

var FAVICON_API_URI = 'https://www.google.com/s2/favicons?domain=',
    renderYear      = require('mag-app').metrics.height >= 720,
    months = [
        gettext('January'),
        gettext('February'),
        gettext('March'),
        gettext('April'),
        gettext('May'),
        gettext('June'),
        gettext('July'),
        gettext('August'),
        gettext('September'),
        gettext('October'),
        gettext('November'),
        gettext('December')
    ];

// var youtube = require('./yt');
/* global STANDALONE */

function contentClickHandler ( $item ) {
    var content = $item.data.value;

    content.getUrl(function ( error, url ) {
        if ( !error && url ) {
            core.intent({
                action: 'play',
                mime: 'content/video',
                data: {
                    uri: url,
                    title: content.title,
                    controls: {
                        pip: !STANDALONE
                    }
                },
                events: {
                    stop: function ( /*event*/ ) {
                        // close intent to go back to app
                        this.close();
                    }
                }
            });
        } else {
            core.notify({
                title: gettext('Error :('),
                icon: 'alert',
                type: 'warning',
                timeout: 1000
            });
        }
    });


}

module.exports = function ( item ) {
    var date = new Date(item.date),
        month, resultDate,
        $img = document.createElement('img');


    month = months[date.getMonth()];

    if ( core.environment.language === 'en' ) {
        resultDate = month + ', ' + date.getDate();
    } else {
        resultDate = date.getDate() + ' ' + month;
    }
    if ( renderYear ) {
        resultDate += ' ' + date.getFullYear();
    }


    $img.src = item.icon || (FAVICON_API_URI + item.source);

    return {
        items: [
            {
                className: 'icon',
                value: $img
            },
            {
                className: 'title',
                value: item.title
            },
            // {
            //     className: 'theme-icon theme-icon-favorite-active' + (item.favorite ? ' active': '')
            // },
            {
                className: 'date',
                value: resultDate
            }
        ],
        value: item,
        click: contentClickHandler
    };
};
